import type { User } from '@repo-level/core-front';
import type { ICMSLottery } from 'api/cms/lottery';
import { groupsExclude, groupsInclude } from 'helpers/cms';

export const isLotteryForPlayer = (
  { visibility }: ICMSLottery,
  user: User | undefined
) => {
  if (!visibility) return true;

  const params = { ...visibility, showGuestToggle: true };

  return groupsInclude(user)(params) && groupsExclude(user)(params);
};
